import { useTheme } from 'next-themes';
import { Toaster as Sonner, ToasterProps } from 'sonner';

const Toaster = ({ ...props }: ToasterProps) => {
	const { theme = 'system' } = useTheme();

	return (
		<Sonner
			theme={theme as ToasterProps['theme']}
			className="toaster group"
			style={
				{
					'--normal-bg': 'hsl(var(--background))',
					'--normal-text': 'hsl(var(--foreground))',
					'--normal-border': 'hsl(var(--border))',
					'--success-bg': 'hsl(142.1 76.2% 36.3%)',
					'--success-text': 'hsl(355.7 100% 97.3%)',
					'--success-border': 'hsl(142.1 76.2% 36.3%)',
					'--error-bg': 'hsl(var(--destructive))',
					'--error-text': 'hsl(var(--destructive-foreground))',
					'--error-border': 'hsl(var(--destructive))',
					zIndex: 9999
				} as React.CSSProperties
			}
			{...props}
		/>
	);
};

export { Toaster };
